import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { linkitApi } from "../api";
import PagePreview from "../components/PagePreview";

export default function PublicPage() {
  const { username } = useParams();
  const [state, setState] = useState({ loading: true, content: null, error: false });

  useEffect(() => {
    let active = true;
    linkitApi.get(`/u/${username}`)
      .then(({ data }) => { if (active) setState({ loading: false, content: data.content, error: false }); })
      .catch(() => { if (active) setState({ loading: false, content: null, error: true }); });
    return () => { active = false; };
  }, [username]);

  if (state.loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0f1117] text-white">
        <Loader2 className="animate-spin" />
      </div>
    );
  }
  if (state.error || !state.content) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[#0f1117] px-6 text-center text-white">
        <p className="text-4xl font-black">404</p>
        <p className="text-white/60">This page doesn&apos;t exist or hasn&apos;t been published yet.</p>
        <a href="/create" className="mt-2 rounded-full bg-indigo-500 px-5 py-2 text-sm font-semibold">Create your own with Linkit</a>
      </div>
    );
  }
  return (
    <div className="min-h-screen" data-testid="public-bio-page">
      <PagePreview content={state.content} username={username} />
    </div>
  );
}
